import { Container, Row } from "reactstrap";
import DefaultStyle from "./DefaultStyle";
import HorizontalStyle from "./HorizontalStyle";
import InlineStyle from "./InlineStyle";
import OfferStyleBorder from "./OfferStyleBorder";
import SolidBorderStyle from "./SolidBorderStyle";
import VariationCheckbox from "./variationCheckbox";
import VariationRadio from "./VariationRadio";
import { FormControlsTitle, MegaOptionsTitle } from "../../../../../constants";
import VerticalStyle from "./VerticalStyle";
import WithoutBordersStyle from "./WithoutBordersStyle";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const MegaOptionsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={MegaOptionsTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <VariationRadio />
          <VariationCheckbox />
          <DefaultStyle />
          <WithoutBordersStyle />
          <SolidBorderStyle />
          <OfferStyleBorder />
          <InlineStyle />
          <VerticalStyle />
          <HorizontalStyle />
        </Row>
      </Container>
    </>
  );
};
export default MegaOptionsContainer;
